const topicsData = [
  { name: '流浪地球3', count: '128万讨论', trend: 'up' },
  { name: '哪吒2票房', count: '96万讨论', trend: 'hot' },
  { name: '封神宇宙', count: '83万讨论', trend: 'up' },
  { name: '国产科幻', count: '71万讨论', trend: 'up' },
  { name: '喜剧之王', count: '65万讨论', trend: '' },
  { name: '悬疑烧脑', count: '58万讨论', trend: 'hot' },
  { name: '治愈系动漫', count: '52万讨论', trend: 'up' },
  { name: '经典港片', count: '47万讨论', trend: '' },
  { name: '纪录片推荐', count: '39万讨论', trend: 'new' },
  { name: '动作大片', count: '34万讨论', trend: '' },
];

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm text-foreground-500 max-w-[560px] mx-auto">当前观众热议的影视话题，加入讨论发现更多好片。</p>
        </div>

        <div className="flex flex-wrap gap-3 justify-center">
          {topicsData.map((topic, i) => (
            <div
              key={i}
              className="group flex items-center gap-2.5 px-4 py-2.5 rounded-full bg-background-50 border border-background-200/60 hover:border-primary-200 hover:bg-primary-50/40 transition-all cursor-pointer"
            >
              {topic.trend === 'hot' && (
                <span className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-fire-line text-sm text-primary-500"></i>
                </span>
              )}
              {topic.trend === 'up' && (
                <span className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-arrow-up-line text-sm text-accent-600"></i>
                </span>
              )}
              {topic.trend === 'new' && (
                <span className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-sparkling-line text-sm text-accent-500"></i>
                </span>
              )}
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors whitespace-nowrap">{topic.name}</span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}